import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { EditMyUserModel } from './edit-my-user.model';

const BASE_PATH = environment.basePath;
const headers = new HttpHeaders({ "Content-Type": "application/json" });

@Injectable({
    providedIn: 'root'
})
export class EditMyUserService {

    constructor(private httpClient: HttpClient) { }

    getUserByEmail(email: string): Observable<EditMyUserModel> {
        return this.httpClient.post<EditMyUserModel>(
            `${BASE_PATH}/bff/home/users/my-profile/edit`, 
            {"email": email},
            { headers: headers });
    }

    updateMyProfileRegister(user: EditMyUserModel): Observable<HttpResponse<EditMyUserModel>> {
        return this.httpClient.put<EditMyUserModel>(`${BASE_PATH}/bff/home/users/my-profile/edit`, user, { headers: headers, observe: 'response' });
    }
}
